import { CONFIG, FEATURE_TOGGLE } from '@/scripts/app-configs/constants'
import store from '@/store'

export default [
  {
    path: '/',
    name: 'home',
    redirect: () => store.getters['system/defaultPage'],
  },
  {
    path: '/tasks',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    redirect: () => {
      return { name: 'feed-home', params: {} }
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "umlLayout" */ '@/views/feed/layouts/feed-default.vue'),
        name: 'feed',
        redirect: () => {
          return { name: 'feed-master-task', params: {} }
        },
        children: [
          {
            path: ':masterTaskId?',
            name: 'feed-master-task',
            component: () => import(/* webpackChunkName: "umlMasterTaskView" */ '@/views/feed/pages/master-task.vue'),
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: '/feed',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "umlLayout" */ '@/views/feed/layouts/feed-default.vue'),
        name: 'feed-home',
        redirect: () => {
          return { name: 'feed-program', params: {} }
        },
        children: [
          {
            path: ':programUuid?',
            name: 'feed-program',
            component: () => import(/* webpackChunkName: "umlMasterTaskView" */ '@/views/feed/pages/master-task.vue'),
            props: true,
            meta: { ignoreSegmentPageView: true },
          },
          {
            path: ':programUuid/tasks/:masterTaskId?',
            name: 'feed-program-tasks',
            component: () => import(/* webpackChunkName: "umlMasterTaskView" */ '@/views/feed/pages/master-task.vue'),
            props: true,
            meta: { ignoreSegmentPageView: true },
          },
        ],
      },
    ],
  },
  {
    path: '/logout',
    name: 'logout',
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "authenticationView" */ '@/views/masters/authentication-view.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/authentication/pages/login.vue'),
        meta: {
          unauthorizedAccess: true,
          checkAppVersion: true,
        },
      },
    ],
  },
  {
    path: '/login-from-cookies',
    component: () => import(/* webpackChunkName: "authenticationView" */ '@/views/masters/authentication-view.vue'),
    children: [
      {
        path: '',
        name: 'login-from-cookies',
        component: () => import(/* webpackChunkName: "loginFromCookies" */ '@/views/authentication/pages/login-from-cookies.vue'),
        meta: {
          unauthorizedAccess: true,
          checkAppVersion: true,
        },
      },
    ],
  },
  {
    path: '/forgot',
    component: () => import(/* webpackChunkName: "authenticationView" */ '@/views/masters/authentication-view.vue'),
    children: [
      {
        path: '',
        name: 'forgot',
        component: () => import(/* webpackChunkName: "forgotPassword" */ '@/views/authentication/pages/forgot-password.vue'),
        meta: { unauthorizedAccess: true },
      },
    ],
  },
  {
    path: '/reset/:token',
    component: () => import(/* webpackChunkName: "authenticationView" */ '@/views/masters/authentication-view.vue'),
    children: [
      {
        path: '',
        name: 'reset',
        component: () => import(/* webpackChunkName: "resetPassword" */ '@/views/authentication/pages/reset-password.vue'),
        meta: { unauthorizedAccess: true },
      },
    ],
  },
  {
    path: '/unlock/:token',
    component: () => import(/* webpackChunkName: "authenticationView" */ '@/views/masters/authentication-view.vue'),
    children: [
      {
        path: '',
        name: 'unlock',
        component: () => import(/* webpackChunkName: "unlockAccount" */ '@/views/authentication/pages/unlock-account.vue'),
        meta: { unauthorizedAccess: true },
      },
    ],
  },
  {
    path: '/chat',
    beforeEnter: (to, from, next) => {
      document.title = `Chat | ${process.env.NODE_ENV === 'development' ? 'DEV - SWORD Health' : 'SWORD Health'}`

      return next()
    },
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    meta: {
      isFeatureEnabled: FEATURE_TOGGLE.USE_UI_PORTAL_CHAT,
    },
    children: [
      {
        path: '',
        name: 'chat',
        component: () => import(/* webpackChunkName: "chat" */ '@/views/chat/pages/chat.vue'),
      },
      {
        path: ':pathMatch(.*)*',
        component: () => import(/* webpackChunkName: "chat" */ '@/views/chat/pages/chat.vue'),
      },
    ],
  },
  {
    path: '/patients-funnel',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    children: [
      {
        path: ':activeFunnel?',
        name: 'patients-funnel',
        component: () => import(/* webpackChunkName: "membersList" */ '@/views/members-list/pages/members-list.vue'),
      },
    ],
  },
  {
    path: '/patient',
    component: () => import(/* webpackChunkName: "clearRoot" */ '@/views/masters/clear-root.vue'),
    children: [
      {
        path: 'add',
        name: 'patient.add',
        component: () => import(/* webpackChunkName: "login" */ '@/views/patient/pages/patient-profile-form.vue'),
        meta: {
          isFeatureEnabled: CONFIG.environment === 'au',
        },
      }, {
        path: ':patientID/edit/:section?',
        name: 'patient.edit',
        component: () => import(/* webpackChunkName: "patientProfileForm" */ '@/views/patient/pages/patient-profile-form.vue'),
      }, {
        path: ':patientID/card',
        name: 'patient.card',
        component: () => import(/* webpackChunkName: "patientCardForm" */ '@/views/patient/pages/patient-card-form.vue'),
      },
    ],
  },
  {
    path: '/patients/:patientID',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    children: [
      {
        path: 'board',
        name: 'profile.board',
        component: () => import(/* webpackChunkName: "patientScreen" */ '@/views/patient/pages/patient-screen.vue'),
      }, {
        path: 'profile',
        name: 'profile.details',
        component: () => import(/* webpackChunkName: "patientDetails" */ '@/views/patient/pages/patient-details.vue'),
      }, {
        path: 'change-state',
        name: 'profile.changeState',
        component: () => import(/* webpackChunkName: "changeState" */ '@/views/patient/pages/change-state.vue'),
      }, {
        path: 'assign-kit',
        name: 'profile.assign-kit',
        component: () => import(/* webpackChunkName: "assignKit" */ '@/views/patient/pages/assign-kit.vue'),
      }, {
        path: 'clinical-history',
        name: 'profile.clinical-history',
        component: () => import(/* webpackChunkName: "patientClinicalHistoryCDA" */ '@/views/patient/pages/patient-clinical-history-cda.vue'),
      }, {
        path: 'treatment-path',
        name: 'profile.treatmentPath',
        component: () => import(/* webpackChunkName: "treatmentPath" */ '@/views/patient/pages/treatment-path.vue'),
      }, {
        path: 'sessions',
        name: 'profile.sessions',
        component: () => import(/* webpackChunkName: "patientPrescribedSessions" */ '@/views/patient/pages/patient-prescribed-sessions.vue'),
      }, {
        // TODO: Deprecate the Move routes below. Remove after 2025-06-01
        path: 'move/prescriptions',
        name: 'profile.move-prescriptions',
        redirect: ({ params }) => {
          return { name: 'prescriptions.move', params: { memberId: params.patientID } }
        },
      }, {
        path: 'move/prescriptions/add',
        name: 'profile.move-prescriptions-add',
        redirect: ({ params }) => {
          return { name: 'prescriptions.move.add', params: { memberId: params.patientID } }
        },
      }, {
        path: 'move/prescriptions/:prescriptionID/edit',
        name: 'profile.move-prescriptions-edit',
        redirect: ({ params }) => {
          return { name: 'prescriptions.move.edit', params: { memberId: params.patientID, prescriptionID: params.prescriptionID } }
        },
      }, {
        path: 'move/prescriptions/:prescriptionID/overview',
        name: 'profile.move-prescriptions-overview',
        redirect: ({ params }) => {
          return { name: 'prescriptions.move.overview', params: { memberId: params.patientID, prescriptionID: params.prescriptionID } }
        },
      },
    ],
  },
  {
    path: '/prescription/:patientID/session/:sessionID?',
    name: 'prescription',
    component: () => import(/* webpackChunkName: "prescription" */ '@/views/prescriptions/thrive/components/Prescription.thrive.vue'),
    children: [
      {
        path: 'prescription-clinical-history-check',
        name: 'prescription.clinicalHistoryCheck',
      }, {
        path: 'messages',
        name: 'prescription.messages',
      }, {
        path: 'prescription-type',
        name: 'prescription.type',
      }, {
        path: 'therapies',
        name: 'prescription.therapies',
      }, {
        path: 'therapy/options',
        name: 'prescription.therapiesOption',
      }, {
        path: 'exercises',
        name: 'prescription.exercises',
      }, {
        path: 'manual-planning',
        name: 'prescription.manual-planning',
      }, {
        path: 'changes',
        name: 'prescription.justify',
      }, {
        path: '/prescription/:patientID/recommendations',
        name: 'prescription.recommendations',
      }, {
        path: '/prescription/:patientID/recommendations/edit',
        name: 'prescription.recommendations.edit',
      }, {
        path: 'exercise-levels/:exerciseID',
        name: 'prescription.exerciselevels',
      }, {
        path: 'summary',
        name: 'prescription.summary',
      }, {
        path: 'summary',
        name: 'prescription.success',
      },
    ],
  },
  {
    path: '/prescriptions',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    children: [
      {
        path: ':memberId',
        component: () => import(/* webpackChunkName: "prescriptionsLayout" */ '@/views/prescriptions/layouts/prescriptions-default.vue'),
        name: 'prescriptions',
        children: [
          {
            path: 'bloom',
            name: 'prescriptions.bloom',
            component: () => import(/* webpackChunkName: "prescriptionsBloom" */ '@/views/prescriptions/bloom/pages/index.bloom.vue'),
          },
          {
            path: 'sword',
            name: 'prescriptions.sword',
            component: () => import(/* webpackChunkName: "prescriptionsSword" */ '@/views/prescriptions/thrive/pages/index.thrive.vue'),
          },
          {
            path: 'move',
            name: 'prescriptions.move',
            component: () => import(/* webpackChunkName: "prescriptionsMove" */ '@/views/prescriptions/move/pages/index.move.vue'),
          },
          {
            path: 'move/:prescriptionID/overview',
            name: 'prescriptions.move.overview',
            component: () =>
              import(/* webpackChunkName: "prescriptionsMoveOverview" */ '@/views/prescriptions/move/pages/overview.move.vue'),
          },
          {
            path: 'move/:prescriptionID/edit',
            name: 'prescriptions.move.edit',
            component: () =>
              import(/* webpackChunkName: "prescriptionsMoveEdit" */ '@/views/prescriptions/move/pages/edit.move.vue'),
          },
          {
            path: 'move/add',
            name: 'prescriptions.move.add',
            component: () =>
              import(/* webpackChunkName: "prescriptionsMoveAdd" */ '@/views/prescriptions/move/pages/add.move.vue'),
          },
          {
            path: 'mind',
            name: 'prescriptions.mind',
            component: () => import(/* webpackChunkName: "prescriptionsMind" */ '@/views/prescriptions/mind/pages/index.mind.vue'),
          },
          {
            path: 'mind/add',
            name: 'prescriptions.mind.add',
            component: () => import(/* webpackChunkName: "prescriptionsMindAdd" */ '@/views/prescriptions/mind/pages/add.mind.vue'),
          },
          {
            path: 'mind/:prescriptionID',
            name: 'prescriptions.mind.week',
            component: () => import(/* webpackChunkName: "prescriptionsMindEdit" */ '@/views/prescriptions/mind/pages/week.mind.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/therapy_results/:patientID',
    component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
    children: [
      {
        path: 'sessions',
        name: 'therapy_results.sessions',
        component: () => import(/* webpackChunkName: "patientResults" */ '@/views/results/pages/patient-results.vue'),
      }, {
        path: 'clinical-sessions',
        name: 'therapy_results.clinical-sessions',
        component: () => import(/* webpackChunkName: "clinicalPatientResults" */ '@/views/results/pages/clinical-patient-results.vue'),
      }, {
        path: 'exercises/:sessionID/group/:sessionGroup',
        name: 'therapy_results.exercises',
        component: () => import(/* webpackChunkName: "sessionResults" */ '@/views/results/pages/session-results.vue'),
      },
    ],
  },
  {
    path: '/assessments/:patientID',
    component: () => import(/* webpackChunkName: "clearRoot" */ '@/views/masters/clear-root.vue'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "clinicalForms" */ '@/views/clinical-records/clinical-forms.vue'),
        children: [
          {
            path: 'new-form',
            name: 'clinical-records.newForm',
            component: () => import(/* webpackChunkName: "clinicalFormsCreation" */ '@/views/clinical-records/pages/create-form-filters.vue'),
          }, {
            path: 'form-answers/:formID',
            name: 'clinical-records.formAnswers',
            component: () => import(/* webpackChunkName: "clinicalFormsAnswers" */ '@/views/clinical-records/pages/clinical-form-answers.vue'),
          },
        ],
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "appMain" */ '@/views/masters/app-main.vue'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "clinicalForms" */ '@/views/clinical-records/clinical-forms.vue'),
            children: [
              {
                path: 'listing',
                name: 'clinical-records.listing',
                component: () => import(/* webpackChunkName: "clinicalFormsListing" */ '@/views/clinical-records/pages/clinical-forms-listings.vue'),
              },
              {
                path: 'fill',
                name: 'clinical-records.fill',
                component: () => import(/* webpackChunkName: "clinicalFormsFill" */ '@/views/clinical-records/pages/clinical-form-fill.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/profile',
    name: 'professional-profile',
    component: () => import(/* webpackChunkName: "personalInformation" */ '@/views/professional/pages/personal-information.vue'),
  },
  {
    path: '/remote-config',
    name: 'remote-config',
    component: () => import(/* webpackChunkName: "professionalOnboarding" */ '@/views/professional/pages/professional-onboarding.vue'),
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import(/* webpackChunkName: "changePassword" */ '@/views/professional/pages/change-password.vue'),
  },
  {
    path: '/preferences',
    name: 'preferences',
    component: () => import(/* webpackChunkName: "preferences" */ '@/views/professional/pages/preferences.vue'),
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: () => import(/* webpackChunkName: "termsAndConditions" */ '@/views/professional/pages/terms-and-conditions.vue'),
  },
  {
    path: '/version',
    name: 'version',
    component: () => import(/* webpackChunkName: "appVersion" */ '@/views/app-version.vue'),
  },
  {
    path: '/unauthorized',
    name: 'unauthorized-view',
    component: () => import(/* webpackChunkName: "unauthorizedView" */ '@/views/unauthorized-view.vue'),
  }, {
    path: '/:catchAll(.*)',
    component: () => import(/* webpackChunkName: "pageNotFound" */ '@/views/page-not-found.vue'),
  },
]
